import FilterValueDTO = App.Data.Explorer.Filter.FilterValueDTO;
import SegmentListItemDTO = App.Data.Segments.SegmentListItemDTO;
import SegmentType = App.Enums.SegmentType;

export const SEGMENT_MODEL = "App\\Models\\Segment";

export type SegmentOption = FilterValueDTO & {
	segmentType: SegmentType;
	dependsOnLostCustomerSegment: boolean;
};

/** A lost-customer filter is a cohort against exactly one other segment. */
export const isSingleChoiceSegment = (nameClean: string | null): boolean =>
	nameClean === "segmentlostcustomer";

export const takesCohortMonths = isSingleChoiceSegment;

const acceptedType = (nameClean: string | null): SegmentType | null => {
	if (nameClean === "segmentcustomer" || nameClean === "segmentlostcustomer") {
		return "customer";
	}

	return nameClean === "segmentreservation" ? "reservation" : null;
};

/**
 * The explorer and dashboard list segments as `SegmentListItemDTO`, the segments
 * module as `SegmentDO`; only these four fields are needed from either.
 */
export type SegmentSource = Pick<
	SegmentListItemDTO,
	"id" | "title" | "type" | "has_dependency_on_lost_customer_segment"
>;

export const toSegmentOption = (segment: SegmentSource): SegmentOption => ({
	id: segment.id ?? null,
	model: SEGMENT_MODEL,
	level: null,
	selection_depth: null,
	sort_order: null,
	label: segment.title,
	segmentType: segment.type,
	dependsOnLostCustomerSegment:
		segment.has_dependency_on_lost_customer_segment,
});

/**
 * A lost-customer filter excludes segments already derived from one, which would
 * make the cohort circular.
 */
export const segmentOptionsFor = (
	nameClean: string | null,
	segments: SegmentOption[],
	{ currentSegmentId = null }: { currentSegmentId?: number | null } = {}
): SegmentOption[] => {
	const wanted = acceptedType(nameClean);

	return segments.filter((segment) => {
		if (currentSegmentId !== null && segment.id === currentSegmentId) {
			return false;
		}

		if (wanted !== null && segment.segmentType !== wanted) {
			return false;
		}

		return !(
			isSingleChoiceSegment(nameClean) && segment.dependsOnLostCustomerSegment
		);
	});
};

export const toFilterValue = (option: SegmentOption): FilterValueDTO => ({
	id: option.id,
	model: option.model,
	level: option.level,
	selection_depth: option.selection_depth,
	sort_order: option.sort_order,
	label: option.label,
});
